// extracted by mini-css-extract-plugin
module.exports = {"bb-events-grid":"bb-events-grid__8OuNk"};